(ns frontend.view.nev.kyc.process.combo-checkbox-editor
  (:require
   [common.localization :as loc]
   [ui.components.input.checkbox :as checkbox]
   [ui.util :as uu]))

(defn view
  [{:keys [state-atom question-meta question-attribute
           answers-atom kyc-entity-editor
           lang-kw save! read-only? mandatory?
           kyc-process process-id]
    :as args}]
  (let [current-value (or (get @answers-atom question-attribute)
                          {:checked? false :checked-children #{}})
        checked? (boolean (:checked? current-value))
        checked-children (set (:checked-children current-value))
        final-parent-label (get-in question-meta [:translations lang-kw])
        update-parent! (fn [new-checked?]
                         (let [new-value (if new-checked?
                                           {:checked? true
                                            :checked-children checked-children}
                                           {:checked? false
                                            :checked-children #{}})]
                           (swap! answers-atom assoc question-attribute new-value)
                           (deref answers-atom)
                           (save!)))

        selection-mode (get question-meta :selection-mode)

        ;; Ensure radio inputs are grouped per editor instance only
        radio-name (str "combo-child-radio-"
                        (or (namespace question-attribute) "")
                        "-"
                        (name question-attribute))

        update-child! (fn [child-key child-checked?]
                        (let [new-children (if child-checked?
                                             (if (= selection-mode :radio)
                                               #{child-key}
                                               (conj checked-children child-key))
                                             (disj checked-children child-key))
                              new-value {:checked? checked?
                                         :checked-children new-children}]
                          (swap! answers-atom assoc question-attribute new-value)
                          (deref answers-atom)
                          (save!)))]

    [:div
     [:div
      {:class "mb-3"}
      [:label
       {:class "flex items-start cursor-pointer text-[0.875rem] font-bold leading-[1rem]"}
       [:div
        {:class "pt-[2.5px]"}
        [checkbox/view
         {:value checked?
          :disabled? read-only?
          :on-change update-parent!}]]

       [:span
        {:class "ml-2"}
        final-parent-label]]]

     [:div
      {:class "ml-6 mt-2"}
      (for [child (:children question-meta)]
        (let [child-key (:key child)
              child-label (:label child)
              child-checked? (contains? checked-children child-key)
              child-disabled? (or read-only? (not checked?))]
          [:div.mb-2
           {:key (str "child-" child-key)}
           [:label
            {:class (uu/cm "flex items-start text-[0.875rem] font-bold leading-[1rem]"
                           (when-not child-disabled? "cursor-pointer")
                           (when child-disabled? "opacity-50"))}
            (if (= selection-mode :radio)
              [:input.mr-2
               {:type "radio"
                :name radio-name
                :class "bg-input-light "
                :checked child-checked?
                :disabled child-disabled?
                :on-change (fn [_]
                             (when (not child-disabled?)
                               (update-child! child-key true)))}]

              [:div
               {:class "pt-[2.5px]"}
               [checkbox/view
                {:value child-checked?
                 :disabled? child-disabled?
                 :on-change (fn [new-checked?]
                              (update-child! child-key new-checked?))}]])
            [:span
             {:class (uu/cm "ml-2 select-none"
                            (when child-disabled?
                              "text-base-light-text-paler"))}
             (if (map? child-label)
               (get child-label lang-kw (get child-label :en ""))
               (if (keyword? child-label)
                 (loc/tr child-label nil lang-kw)
                 child-label))]]]))]]))
